// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search__result {
  margin: 0 0 35px;
  display: block;
}

.search__multiline-description {
  margin-bottom: 7px;
  margin: var(--base-sizes-0);
  --tw-text-opacity: 1;
  color: rgb(50 50 50 / var(--tw-text-opacity));
}

.search__multiline-description:last-of-type {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/Search/Search.css","webpack://./services/frontend/app/pages/Search/Search.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".search__result {\n  display: block;\n  margin: 0 0 35px;\n}\n\n.search__multiline-description {\n  margin-bottom: 7px;\n  margin: var(--base-sizes-0);\n  --tw-text-opacity: 1;\n  color: rgb(50 50 50 / var(--tw-text-opacity));\n}\n\n.search__multiline-description:last-of-type {\n    margin-bottom: 0;\n  }\n",".search__result {\n  margin: 0 0 35px;\n  display: block;\n}\n\n.search__multiline-description {\n  margin-bottom: 7px;\n  margin: var(--base-sizes-0);\n  --tw-text-opacity: 1;\n  color: rgb(50 50 50 / var(--tw-text-opacity));\n}\n\n.search__multiline-description:last-of-type {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
